import Vue from 'vue';
import GSignInButton from 'vue-google-signin-button';
import App from './App.vue';
import router from './router';
// import axios from '../apiService/config';
import axios from './apiService/config/axios.js';
import Login from './components/Login';
import Soporte from './components/Soporte_linea7x24';
import Login_gmail from './components/Login-gmail';
import Loading from './components/Loading';


import 'chart.js';
import 'hchs-vue-charts';
// import BootstrapVue from 'bootstrap-vue';

// import donut_chart from './js/donut'
import {
  store,
} from './js/store';

import VueRouter from 'vue-router';
// import vuetify from './plugins/vuetify';
import vuetify from './js/vuetify';

Vue.use(window.VueCharts);
// Vue.use(BootstrapVue);
Vue.use(GSignInButton);

export const serverBus = new Vue();

if (process.env.NODE_ENV === 'production') {
  window.onbeforeunload = function (event) { // Funcion para evitar recargar la pagina
    const mensaje = '¿Estas seguro de salir?';
    if (/Firefox[\/\s](\d+)/.test(navigator.userAgent) && new Number(RegExp.$1) >= 4) {
      alert(mensaje);
    }
    return mensaje;
  };
}

router.beforeEach((to, from, next) => {
  if (to.name != 'Login') {
    if (store.state.user == '' || store.state.user == null) {
      next(false);
    } else {
      next(true);
    }
  } else {
    store.state.user = '';
    next(true);
  }
});

new Vue({
  el: '#app',

  vuetify,
  components: {
    App,
    Login,
    Soporte,
    Login_gmail,
    Loading,
  },
  router,
  axios,
  store,
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js